import numeral from "numeral";

// ----------------------------------------------------------------------

export function fCurrency(number) {
  return numeral(number).format(Number.isInteger(number) ? "$0,0" : "$0,0.00");
}
export function fCurrencySymbol(number) {
  return numeral(number).format(Number.isInteger(number) ? "0,0" : "0,0.00");
}
export function fPercent(number) {
  return numeral(number / 100).format("0.0%");
}

export function fPercentExact(number) {
  return ((number / 100) * 100).toFixed(2) + "%";
}

export function fNumber(number) {
  return numeral(number).format();
}

export function fShortenNumber(number) {
  return numeral(number).format("0.00a").replace(".00", "");
}

export function fData(number) {
  return numeral(number).format("0.0 b");
}

export const nFormatter = (num) => {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return num;
};
export const nFormatterChart = (num) => {
  if (Math.abs(num) >= 1000000000) {
    return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
  }
  if (Math.abs(num) >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (Math.abs(num) >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return num.toFixed(2);
};

export const abDivide = (a, b) => {
  return (Math.round((a / b) * 100) / 100).toFixed(2);
};

export function fCurrencyWithoutDecimal(number) {
  return numeral(number).format("$0,0");
}
export function fPercentWithoutSymbol(number) {
  return ((number / 100) * 100).toFixed(2);
}
